/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import { ImageContent, LANDING_TYPE_CONTENT, PassageSyncContent } from "src/modules/pe-landing-module/data/interfaces"
import useColumnsCount from "src/modules/pe-landing-module/hooks/useColumnsCount"
import useComponentData from "src/modules/pe-landing-module/hooks/useComponentData"
import { IPrimitiveProps } from "../../section/Primitive"
import ImagePrimitive from "../ImagePrimitive"
import PassageImageContainer from "./PassageImageContainer"
import PassageItemEditForm from "../../landing-edit/editors/passage/PassageItemEditForm"
import { ILandingConsoleStore, useLandingConsoleStore } from "src/modules/pe-landing-module/data/store"

/* Protopia Ecosystem component */  
const SyncPassagePrimitive = (props: IPrimitiveProps): JSX.Element => { 
    const currentDimensionEdit          = useLandingConsoleStore((state: ILandingConsoleStore) => state.currentDimensionEdit)
    const primitive: PassageSyncContent = useComponentData<PassageSyncContent>(( props.primitive || {dimensions: {}} ) as PassageSyncContent )
    const items: ImageContent[] = primitive.items 
    const columns = useColumnsCount(primitive.columns)
    useEffect(() => {
        addCSSClass(
            `landing-passage-${ primitive.id }`,
            `.landing-passage-${ primitive.id } {
                margin-left: -${ primitive.gap / 2 }px;
                margin-right: -${ primitive.gap / 2 }px;
                width: auto!important;
                .passage-container {
                    width: 100%;
                    display: flex;
                    justify-content: center;
                    flex-wrap: wrap;
                    flex-direction: row !important;
                    gap:${ primitive.gap }px;
                    columns: ${ columns };
                }
            }
            .landing-passage-column-${ primitive.id } {
                width: calc(${ Math.floor(100 / columns) }% - ${primitive.gap}px); 
            }`
        )
        return () => {
            removeCSSClass( `landing-passage-${ primitive.id }` )
        }
    }, [])
    if(!primitive.items?.length) return <></>
    return !!items.length
        ?
        <div 
            className={`pe-primitive-container landing-passage-primitive landing-passage-${primitive.id} ${primitive.className || ""}`} 
            style={{ gap: primitive.gap }}
            data-primitive-type={ primitive[ "data-primitive-type" ] }
        >  
            <div className="passage-container d-flex flex-wrap">   
                {
                    items 
                        .map((item: any, i) => { 
                            const _primitive : ImageContent = { 
                                ...item, 
                                data: {
                                    ...item,
                                    hover_size: primitive.hover_size,
                                    src_type: primitive.src_type || "div",
                                },
                                position: {
                                    height: primitive.itemHeight,
                                    width: "100%",
                                },
                                border: primitive.border,
                                type: LANDING_TYPE_CONTENT.IMAGE,
                                className: `${item.className || ""} ${primitive.className || ""}`, 
                            };
                            const width  = `calc(${ Math.floor(100 / columns) }% - ${primitive.gap || 0}px)`
                            const height = primitive.itemHeight || "100%"
                            return <div 
                                key={item.id} 
                                style={{ 
                                    width, 
                                    height,
                                }}
                            >
                                <PassageImageContainer width={width} height={height} i={i} animated={primitive.animated}  animated_delay={primitive.animated_delay}>
                                    <PassageItemEditForm i={ i } primitive={ _primitive } items={items}  >                                        
                                        <ImagePrimitive
                                            i={i}
                                            primitive={ _primitive as ImageContent }
                                        />
                                    </PassageItemEditForm>
                                </PassageImageContainer>
                            </div>
                        })
                }  
            </div> 
        </div>
        :
        <></>
}

export default SyncPassagePrimitive